/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines the different redirect/uri types
 * @export
 */
export const RedirectTypeConstants = {
    HREF: 'HREF',
    JSFHREF: 'JSFHREF',
    ExternalHREF: 'ExternalHREF'
} as const;
export type RedirectTypeConstants = typeof RedirectTypeConstants[keyof typeof RedirectTypeConstants];


export function RedirectTypeConstantsFromJSON(json: any): RedirectTypeConstants {
    return RedirectTypeConstantsFromJSONTyped(json, false);
}

export function RedirectTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedirectTypeConstants {
    return json as RedirectTypeConstants;
}

export function RedirectTypeConstantsToJSON(value?: RedirectTypeConstants | null): any {
    return value as any;
}

